module.exports = __webpack_public_path__ + "img/av320.2b637335.png";